import React from "react";
import { Modal, Button } from "react-bootstrap";

const EditSuccessModal = ({ show, onClose }) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Success</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Client identifiers were updated successfully.
        <br />
        This page will reload automatically in 5 seconds.
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onClose}>
          Close and Reload
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditSuccessModal;